import { formatDate } from "common/service/CommonService";

export const labels: Record<string, string> = {
  // Study Identification
  studytitle: "Study Title",
  studycode: "Study Code / ID",
  versionnumber: "Version Number",
  protocolversiondate: "Protocol Version Date",

  // Sponsor & CRO Details
  sponsorname: "Sponsor Name",
  croname: "CRO Name",

  // Regulatory & Ethics
  ethicscommitteename: "Ethics Committee Name",
  ethicsapprovaldate: "Ethics Approval Date",
  regulatoryauthority: "Regulatory Authority",

  // Study Design
  studytype: "Study Type",
  studydesign: "Study Design",
  numberoftreatments: "Number of Treatments",
  numberofperiods: "Number of Periods",
  numberofaliquots: "Number of Aliquots",
  numberofsequences: "Number of Sequences",
  fastingcondition: "Fasting / Fed Condition",

  // Subject Details
  totalsubjects: "Total Subjects ",
  extrasubjects: "Extra Subjects",
  gender: "Gender",
  agemin: "Age Range (Min)",
  agemax: "Age Range (Max)",
  bmimin: "BMI Range (Min)",
  bmimax: "BMI Range (Max)",

  // Investigational Product
  testdrugname: "Test Drug Name",
  testdosageform: "Dosage Form",
  teststrength: "Strength",
  testbatchno: "Batch No",
  testmanufacturer: "Manufacturer",
  testexpirydate: "Expiry Date",
  refdrugname: "Reference Drug Name",
  refdosageform: "Reference Dosage Form",
  refstrength: "Reference Strength",
  refbatchno: "Reference Batch No",
  refmanufacturer: "Reference Manufacturer",
  refmanufacturingdate: "Reference Manufacturing Date",
  refexpirydate: "Reference Expiry Date",

  // Study Timeline
  screeningdate: "Screening Date",
  screeningvalidity: "Screening Validity",
  washoutdays: "Washout Period (days)",

  // Dosing Details
  dosestrength: "Dose Strength",
  routeofadministration: "Route of Administration",
  dosingtime: "Dosing Time",
  watervolume: "Water Volume (ml)",
  foodrestrictions: "Food Restrictions",
  lightcondition: "Light Condition",
  subjectinterval: "Subject Interval",
  predosewindowminutes: "Predose Window (Minutes)",

  // Sample Collection
  biologicalmatrix: "Biological Matrix",
  totalsamplingpoints: "Total Sampling Points",
  sampleprocessingmethod: "Sample Processing Method",
  samplingpoints: "Sampling Points",
  storagetemperature: "Storage Temperature",

  // Additional
  registrationnumber: "Clinical Trial Registration No.",
  studystatus: "Study Status",
  indicationdisease: "Indication / Disease",
  sponsoremail: "Email",
  sponsorcontact: "Contact",
  startdate: "Study Start Date",
  enddate: "Study End Date",
};


export const truncateWithTooltip = (value: any, max = 30) => {
  if (!value || typeof value !== "string") return value;
  const isLong = value.length > max;
  const display = isLong ? value.slice(0, max) + "..." : value;
  return <span title={isLong ? value : ""}>{display}</span>;
};

export const renderStudyValue = (key: string, value: any) => {
  if (key.includes("date") || key.includes("Date")) {
    if (!value) return <span className="text-muted">—</span>;
    const formatted = formatDate(value);
    return formatted || <span className="text-muted">—</span>;
  }
  if (value === null || value === undefined || value === "") {
    return <span className="text-muted">—</span>;
  }
  else if (key === "samplingpoints") {
    return Array.isArray(value) ? value.join(", ") : value;
  }
  return value;
};